import api from "../../config/http-common";

const buildQuery = (payload) => {
  let query =
    "?pageNumber=" + payload.pageNumber + "&pageSize=" + payload.pageSize;

  return query;
};

const getGenetecAccessLevel = (payload) => {
  return api
    .securedAxios()
    .get("/api/v4/accessRule/list" + buildQuery(payload));
};

const getGenetecCardHolder = (payload) => {
  return api
    .securedAxios()
    .get("/api/v4/cardHolderGroup/list" + buildQuery(payload));
};

const addGenetecAccessLevelAndCardHolderToMSGP = (payload) => {
  return api.securedAxios().put("/api/v4/genetec/msgp", payload);
};

const getAccessLevelAndIntegrationLists = (payload) => {
  return api.securedAxios().get("/api/v4/integration/list", {
    params: {
      pageNumber: payload.pageNumber,
      pageSize: payload.pageSize,
      accessType: payload.accessType.join(","),
    },
  });
};

const GenetecService = {
  getGenetecAccessLevel,
  getGenetecCardHolder,
  addGenetecAccessLevelAndCardHolderToMSGP,
  getAccessLevelAndIntegrationLists,
};

export default GenetecService;
